import api from './api';
import { Notification } from '../types/models';

export interface NotificationsResponse {
  notifications: Notification[];
  unreadCount: number;
}

export async function listNotifications(): Promise<NotificationsResponse> {
  const res = await api.get('/notifications');
  return res.data;
}

export async function markNotificationsRead(notificationIds?: string[]): Promise<void> {
  await api.put('/notifications/read', notificationIds ? { notificationIds } : {});
}
